<div class="table-responsive">
    <div class="card">
        <div class="card-body">

            <div class="row">
                <div class="col-md-12">
                    <div class="button-items" style="float: left;padding-left: 1%;">
                        <h2>Time Records</h2>
                    </div>
                    <div class="button-items" style="float: right;display: flex;">
                        <div class="search-container m-0">
                            <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchTerm"
                                (keyup.enter)="loadTimeData(lastTableLazyLoadEvent)">
                            <button class="search-button" style="padding-bottom: 3px;"
                                (click)="loadTimeData(lastTableLazyLoadEvent)"
                                pTooltip="Search time records" appActionTooltip>
                                <img src="assets/images/search.png" alt="Search">
                            </button>
                            <button class="search-button sb-close btn-lg"
                                (click)="searchTerm='';loadTimeData(lastTableLazyLoadEvent)"
                                pTooltip="Clear search" appActionTooltip>
                                <i class="mdi mdi-window-close"></i></button>
                        </div>
                        <button class="btn btn-primary btn-sm m-1" (click)="loadTimeData(lastTableLazyLoadEvent)"
                            pTooltip="Refresh table" appActionTooltip><i class="mdi mdi-reload"></i></button>
                        <button class="btn btn-primary btn-sm m-1" (click)="clearAllFilters(dt)"
                            pTooltip="Clear all filters" appActionTooltip>Clear
                            <i class="mdi mdi-filter-remove"></i></button>
                        <span appActionTooltip *ngIf="(auth.roles?.includes('ADMIN') || auth.roles?.includes('Reporting')) && !tkdashboard"
                            [pTooltip]="exportLoading ? 'Export already in progress, please wait' : 'Export to Excel'"
                            [actionDisabled]="exportLoading">
                            <button class="btn btn-success btn-sm m-1" (click)="exportTimeRecords()" [disabled]="exportLoading">
                                <span *ngIf="!exportLoading">
                                    <i class="mdi mdi-file-excel"></i> Export
                                </span>
                                <span *ngIf="exportLoading">
                                    <i class="mdi mdi-loading mdi-spin"></i> Exporting...
                                </span>
                            </button>
                        </span>
                        <span appActionTooltip *ngIf="onlytk || tkdashboard || enableMultiRejectBtn"
                            [pTooltip]="selectedRows.length === 0 ? 'Select at least one row to submit' : 'Submit selected time records'"
                            [actionDisabled]="selectedRows.length === 0">
                            <button class="btn btn-success btn-sm  m-1" (click)="submitMultiple()"
                                [disabled]="selectedRows.length === 0">
                                Submit
                            </button>
                        </span>
                        <span appActionTooltip *ngIf="onlytk || tkdashboard"
                            [pTooltip]="selectedRows.length === 0 ? 'Select at least one row to delete' : 'Delete selected time records'"
                            [actionDisabled]="selectedRows.length === 0">
                            <button class="btn btn-danger btn-sm  m-1"
                                (click)="deleteTR(selectedRows)" [disabled]="selectedRows.length === 0">
                                Delete
                            </button>
                        </span>
                        <span appActionTooltip *ngIf="enableMultiRejectBtn && !onlytk && !tkdashboard"
                            [pTooltip]="selectedRows.length === 0 ? 'Select at least one row to reject' : 'Reject selected time records'"
                            [actionDisabled]="selectedRows.length === 0">
                            <button class="btn btn-danger btn-sm  m-1" (click)="rejectMultiple()"
                                [disabled]="selectedRows.length === 0">
                                Reject
                            </button>
                        </span>
                    </div>
                    <div style="float: right;margin-right: 2%;">
                        <p-tabView (onChange)="handleTabChange(dt,$event)" *ngIf="combroles && !dashboard">
                            <p-tabPanel header="LPC/ADMIN">
                            </p-tabPanel>
                            <p-tabPanel header="TK">
                            </p-tabPanel>
                        </p-tabView>
                    </div>

                    <select class="form-status-select" [(ngModel)]="selectedFilterOption" *ngIf="!dashboard"
                        (change)='loadTimeData(lastTableLazyLoadEvent,dt)' title="My Time Records">
                        <option *ngFor="let filter of filterOptions" [ngValue]="filter.value">{{filter.label}}</option>
                    </select>

                    <div style="float:right">
                        <button
                            [style.visibility]="activeTab === 'user' ? 'visible' : 'hidden'"
                            class="btn btn-link p-0 mr-2"
                            (click)="viewGridSettings()"
                            pTooltip="Customize grid columns" appActionTooltip style="cursor: pointer;">
                            <i class="mdi mdi-cog fs-5 text-primary"></i>
                        </button> 
                    </div>
                    <div style="float: right;margin-right: 1%;margin-top: -0.5%">
                        <p-tabView (onChange)="handleTableTabChange($event)">
                            <p-tabPanel header="Default">
                            </p-tabPanel>
                            <p-tabPanel header="Custom">
                            </p-tabPanel>
                        </p-tabView>
                        
                    </div> 

                </div>
            </div>
            <p-table [(selection)]="selectedRows"
                selectionMode="multiple"
                [lazy]="true"
                #dt
                [columns]="cols"
                (onLazyLoad)="loadTimeData($event)"
                [value]="timeRecords"
                dataKey="id"
                styleClass="p-datatable-timeRecords"
                [rowHover]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10,25,50]"
                [loading]="loading"
                responsiveLayout="scroll"
                [paginator]="true"
                [autoLayout]="true"
                [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [filterDelay]="0"
                paginatorDropdownAppendTo="body">

                <!-- ================= HEADER ================= -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <!-- SELECTION -->
                        <th>
                            <p-tableHeaderCheckbox (click)="selectAllFilter()"></p-tableHeaderCheckbox>
                        </th>

                        <!-- ACTIONS -->
                        <th style="width:6rem; white-space:nowrap;">Actions</th>

                        <th pSortableColumn="projectName">
                            <div class="flex justify-content-between align-items-center">
                                Project Name
                                <p-sortIcon field="projectName"></p-sortIcon>
                                <p-columnFilter type="text" field="projectName"
                                    matchMode="contains"
                                    display="menu"
                                    [showOperator]="false"
                                    [showAddButton]="false">
                                </p-columnFilter>
                            </div>
                        </th>
                        
                        <th pSortableColumn="projectId">
                            <div class="flex justify-content-between align-items-center">
                                Project Id
                                <p-sortIcon field="projectId"></p-sortIcon>
                                <p-columnFilter type="numeric"
                                    field="projectId"
                                    matchMode="equals"
                                    [useGrouping]="false"
                                    display="menu"
                                    [showOperator]="false"
                                    [showAddButton]="false"
                                    [showMatchModes]="true"
                                    [matchModeOptions]="matchModeOptionsNumber">
                                </p-columnFilter>
                            </div>
                        </th>

                        <th pSortableColumn="taskName">
                            <div class="flex justify-content-between align-items-center">
                                Task Name
                                <p-sortIcon field="taskName"></p-sortIcon>
                                <p-columnFilter type="text" field="taskName"
                                    matchMode="contains"
                                    display="menu"
                                    [showOperator]="false"
                                    [showAddButton]="false">
                                </p-columnFilter>
                            </div>
                        </th>

                        <th pSortableColumn="taskId">
                            <div class="flex justify-content-between align-items-center">
                                Task Id
                                <p-sortIcon field="taskId"></p-sortIcon>
                                <p-columnFilter type="numeric"
                                    field="taskId"
                                    matchMode="equals"
                                    [useGrouping]="false"
                                    display="menu"
                                    [showOperator]="false"
                                    [showAddButton]="false"
                                    [showMatchModes]="true"
                                    [matchModeOptions]="matchModeOptionsNumber">
                                </p-columnFilter>
                            </div>
                        </th>

                        <th pSortableColumn="id">
                            <div class="flex justify-content-between align-items-center">
                                Time Record Id
                                <p-sortIcon field="id"></p-sortIcon>
                                <p-columnFilter type="numeric"
                                    field="id"
                                    matchMode="equals"
                                    [useGrouping]="false"
                                    display="menu"
                                    [showOperator]="false"
                                    [showAddButton]="false"
                                    [showMatchModes]="true"
                                    [matchModeOptions]="matchModeOptionsNumber">
                                </p-columnFilter>
                            </div>
                        </th>

                        <!-- DYNAMIC COLUMNS -->
                        <ng-container *ngFor="let col of cols">
                            <th *ngIf="col.visible" [pSortableColumn]="col.disableActions ? null : col.field">
                                <div class="flex justify-content-between align-items-center">
                                    {{ col.header }}
                                    <p-sortIcon [field]="col.field" *ngIf="!col.disableActions"></p-sortIcon>

                                    <ng-container *ngIf="!col.disableActions">
                                        <ng-container [ngSwitch]="col.field">

                                        <!-- DATE FIELDS -->
                                        <p-columnFilter *ngSwitchCase="'date'"
                                            #dateFilter
                                            type="date"
                                            field="date"
                                            [showMatchModes]="false"
                                            [showOperator]="false"
                                            [matchModeOptions]="matchModeOptionsDate"
                                            [showAddButton]="false"
                                            display="menu"
                                            [showClearButton]="false"
                                            [showApplyButton]="false">

                                            <ng-template pTemplate="filter">
                                                <div>
                                                    <p-dropdown
                                                        [options]="matchModeOptionsDate"
                                                        (onChange)="onDateFilterChange('date')"
                                                        [(ngModel)]="filterDatesMatchModes.date">
                                                    </p-dropdown>
                                                </div>

                                                <div [ngSwitch]="filterDatesMatchModes.date">
                                                    <div *ngSwitchCase="'betweenDate'">
                                                        <p-calendar [(ngModel)]="filterDates.date"
                                                            (onSelect)="onDateSelect('date',$event)"
                                                            selectionMode="range"
                                                            [readonlyInput]="true">
                                                        </p-calendar>
                                                    </div>
                                                    <div *ngSwitchDefault>
                                                        <p-calendar [(ngModel)]="filterDates.date"
                                                            selectionMode="single"
                                                            [readonlyInput]="true">
                                                        </p-calendar>
                                                    </div>
                                                </div>

                                                <div class="flex items-center" style="float:right">
                                                    <button type="button" class="btn btn-primary"
                                                        (click)="applyDatesFilter('date');dateFilter.hide()"
                                                        pTooltip="Apply date filter" appActionTooltip>Apply</button>
                                                    <button type="button" class="btn btn-danger"
                                                        (click)="clearDatesFilter('date');dateFilter.hide()"
                                                        pTooltip="Clear date filter" appActionTooltip>Clear</button>
                                                </div>
                                            </ng-template>
                                        </p-columnFilter>

                                        <!-- TASK STATUS -->
                                    <p-columnFilter *ngSwitchCase="'taskStatusCode'"
                                        field="taskStatusCode"
                                        display="menu"
                                        [showMatchModes]="false"
                                        [showOperator]="false"
                                        [showAddButton]="false"
                                        >

                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-multiSelect [maxSelectedLabels]="10000"
                                                [ngModel]="value"
                                                [options]="statuses"
                                                (onChange)="filter($event.value)"
                                                optionLabel="label"
                                                placeholder="Any">

                                                <ng-template let-option pTemplate="item">
                                                    <div class="p-multiselect-representative-option">
                                                        <span [class]="'customer-badge status-' + option.value">
                                                            {{ option.label }}
                                                        </span>
                                                    </div>
                                                </ng-template>

                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>

                                    <!-- STATE -->
                                    <p-columnFilter *ngSwitchCase="'stateCode'"
                                        field="stateCode"
                                        matchMode="equals"
                                        display="menu"
                                        [showMatchModes]="true"
                                        [showOperator]="false"
                                        [showAddButton]="false">

                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown
                                                [ngModel]="value"
                                                [options]="stateCodeMapList"
                                                (onChange)="filter($event.value)"
                                                placeholder="Any">

                                                <ng-template let-option pTemplate="item">
                                                    <span [class]="'customer-badge status-' + option.value">
                                                        {{ option.label }}
                                                    </span>
                                                </ng-template>
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>

                                        <!-- BILLABLE -->
                                        <p-columnFilter *ngSwitchCase="'isBillable'"
                                            field="isBillable"
                                            matchMode="equals"
                                            [showMatchModes]="false"
                                            [showOperator]="false"
                                            [showAddButton]="false"
                                            [showClearButton]="true"
                                            [showApplyButton]="true"
                                            display="menu">

                                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                <p-dropdown [ngModel]="value"
                                                    [options]="billableList"
                                                    (onChange)="filter($event.value)"
                                                    placeholder="Any">
                                                </p-dropdown>
                                            </ng-template>
                                        </p-columnFilter>

                                        <!-- TIME RECORD STATUS -->
                                        <p-columnFilter *ngSwitchCase="'timeRecordStatus'"
                                            field="timeRecordStatus"
                                            matchMode="equals"
                                        [showMatchModes]="false"
                                        [showOperator]="false"
                                        [showAddButton]="false"
                                        [showClearButton]="true"
                                        [showApplyButton]="true"
                                            display="menu">

                                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                <p-multiSelect [maxSelectedLabels]="10000" [ngModel]="value"
                                                    [options]="timeRecStatusList"
                                                    placeholder="Any"
                                                    (onChange)="filter($event.value)"
                                                    optionLabel="label">
                                                </p-multiSelect>
                                            </ng-template>
                                        </p-columnFilter>

                                        <!-- DEFAULT TEXT FILTER -->
                                         <ng-container *ngSwitchDefault>
                                            <ng-container [ngSwitch]="col.filterType">

                                                <!-- DATE -->
                                                <p-columnFilter *ngSwitchCase="'date'"
                                                    [field]="col.field"
                                                    type="date"
                                                    display="menu"
                                                    [showMatchModes]="false"
                                                    [showOperator]="false"
                                                    [showAddButton]="false"
                                                    [showClearButton]="false"
                                                    [showApplyButton]="false">

                                                    <ng-template pTemplate="filter">
                                                        <p-dropdown
                                                            [options]="matchModeOptionsDate"
                                                            [(ngModel)]="filterDatesMatchModes[col.field]"
                                                            (onChange)="onDateFilterChange(col.field)">
                                                        </p-dropdown>

                                                        <p-calendar
                                                            [(ngModel)]="filterDates[col.field]"
                                                            [selectionMode]="filterDatesMatchModes[col.field] === 'betweenDate' ? 'range' : 'single'"
                                                            [readonlyInput]="true">
                                                        </p-calendar>

                                                        <div class="flex items-center" style="float:right">
                                                            <button class="btn btn-primary"
                                                                (click)="applyDatesFilter(col.field)"
                                                                pTooltip="Apply date filter" appActionTooltip>Apply</button>
                                                            <button class="btn btn-danger"
                                                                (click)="clearDatesFilter(col.field)"
                                                                pTooltip="Clear date filter" appActionTooltip>Clear</button>
                                                        </div>
                                                    </ng-template>
                                                </p-columnFilter>


                                                <!-- BOOLEAN -->
                                                <p-columnFilter *ngSwitchCase="'boolean'"
                                                    [field]="col.field"
                                                    matchMode="equals"
                                                    display="menu"
                                                    [showMatchModes]="false"
                                                    [showOperator]="false"
                                                    [showAddButton]="false"
                                                    [showClearButton]="true"
                                                    [showApplyButton]="true">

                                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                        <p-dropdown
                                                            [ngModel]="value"
                                                            [options]="[
                                                                        { label: 'Yes', value: 'Yes' },
                                                                        { label: 'No', value: 'No' }
                                                                    ]"
                                                            (onChange)="filter($event.value)"
                                                            placeholder="Any">
                                                        </p-dropdown>
                                                    </ng-template>
                                                </p-columnFilter>


                                                <!-- NUMERIC -->
                                                <p-columnFilter *ngSwitchCase="'numeric'"
                                                    type="numeric"
                                                    [field]="col.field"
                                                    display="menu"
                                                    [useGrouping]="false"
                                                    [showOperator]="false"
                                                    [showAddButton]="false">
                                                </p-columnFilter>


                                                <!-- TEXT (Default) -->
                                                <p-columnFilter *ngSwitchDefault
                                                    type="text"
                                                    [field]="col.field"
                                                    matchMode="contains"
                                                    display="menu"
                                                    [showOperator]="false"
                                                    [showAddButton]="false">
                                                </p-columnFilter>

                                            </ng-container>
                                        </ng-container>


                                    </ng-container>
                                    </ng-container>

                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>

                <!-- ================= BODY ================= -->
                <ng-template pTemplate="body" let-timeRecordData let-columns="columns">
                    <tr
                        [ngStyle]="timeRecordData.approveRejectBy === 'SYSTEM'
                            ? {'background-color': 'color-mix(in oklab, var(--al-primary) 18%, var(--al-surface))', 'font-weight': 700}
                            : {}">

                        <!-- SELECTION -->
                        <td>
                            <span appActionTooltip
                                [pTooltip]="timeRecordData.disableTrSelection ? timeRecordData.disableTrSelectionTitle : 'Select this time record'"
                                [actionDisabled]="timeRecordData.disableTrSelection">
                                <p-tableCheckbox
                                    [value]="timeRecordData"
                                    [disabled]="timeRecordData.disableTrSelection"
                                    [ngClass]="{'checkbox-not-allowed': timeRecordData.disableTrSelection}">
                                </p-tableCheckbox>
                            </span>
                        </td>

                        <!-- ACTIONS -->
                        <td>
                            <div class="flex align-items-center gap-2">

                                <!-- VIEW -->
                                <button class="btn btn-warning btn-sm"
                                    (click)="openViewTimeRecord(timeRecordData)"
                                    pTooltip="View time record" appActionTooltip>
                                    <i class="mdi mdi-eye"></i>
                                </button>

                                <!-- EDIT -->
                                <span appActionTooltip
                                    *ngIf="onlytk || tkdashboard"
                                    [pTooltip]="timeRecordData.disableEditFlag ? timeRecordData.disableEditFlagTitle : 'Edit time record'"
                                    [actionDisabled]="timeRecordData.disableEditFlag">
                                    <button class="btn btn-info btn-sm"
                                        [disabled]="timeRecordData.disableEditFlag"
                                        (click)="openEditTimeRecord(timeRecordData)">
                                        <i class="mdi mdi-pencil"></i>
                                    </button>
                                </span>

                                <!-- ACCEPT / REJECT -->
                                <span appActionTooltip
                                    *ngIf="lpcdashboard || (!tkdashboard && !onlytk)"
                                    [pTooltip]="timeRecordData.disableAcceptRejectFlag ? timeRecordData.disableAcceptRejectFlagTitle : 'Accept / Reject time record'"
                                    [actionDisabled]="timeRecordData.disableAcceptRejectFlag">
                                    <button class="btn btn-success btn-sm"
                                        [disabled]="timeRecordData.disableAcceptRejectFlag"
                                        (click)="openApproveTimeRecord(timeRecordData)">
                                        <i class="mdi mdi-clipboard-check-outline"></i>
                                    </button>
                                </span>

                            </div>
                        </td>

                        <!-- STATIC DATA -->
                        <td>{{ timeRecordData.projectName }}</td>
                        <td>{{ timeRecordData.projectId }}</td>
                        <td>{{ timeRecordData.taskName }}</td>
                        <td>{{ timeRecordData.taskId }}</td>
                        <td>{{ timeRecordData.id }}</td>

                        <!-- DYNAMIC DATA -->
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.visible">
                                <ng-container [ngSwitch]="col.field">
                                    <ng-container *ngSwitchCase="'enteredTime'">
                                        {{ timeRecordData['amountOfTime'] | minutesToTime }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'stateCode'">
                                        {{ timeRecordData.stateDesc }}
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        {{ timeRecordData[col.field] }}
                                    </ng-container>

                                    <ng-container *ngIf="col.showHistoryIcon == true">
                                            <ng-container
                                                *ngTemplateOutlet="historyTemplate; "></ng-container>
                                        </ng-container>
                                        
                                        <ng-template #historyTemplate>
                                            <span class="history-icon" pTooltip="View audit history" appActionTooltip>
                                                <i class="mdi mdi-history" [ngStyle]="{
                                                  'color': 'var(--al-success)',
                                                  'opacity': 1,
                                                  'cursor': 'pointer'
                                               }" (click)="showAuditData(timeRecordData, col.field, col.header)"
                                                    tabindex="0">
                                                </i>
                                            </span>
                                        </ng-template>
                                </ng-container>
                            </td>
                        </ng-container>

                    </tr>
                </ng-template>

                <!-- ================= EMPTY ================= -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="(columns?.length || 0) + 7">
                            No records found
                        </td>
                    </tr>
                </ng-template>

            </p-table>

        </div>
    </div>
</div>

<p-dialog [(visible)]="showTrDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
    [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <app-notification [errorMsg]="errorMsg"></app-notification>

        <form [formGroup]="timeForm">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="taskName" class="form-label">Task Name
                                            <ng-container *ngIf="getFieldInfo('taskName') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="taskName"  readonly 
                                            id="taskName">
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="projectName" class="form-label">Project Name
                                            <ng-container *ngIf="getFieldInfo('projectName') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="projectName"  readonly 
                                            id="projectName">
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="matterName" class="form-label">Matter Name
                                            <ng-container *ngIf="getFieldInfo('matterName') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="matterName"  readonly 
                                            id="matterName">
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="organizationName" class="form-label">Organization Name
                                            <ng-container *ngIf="getFieldInfo('organizationName') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="organizationName"
                                            readonly id="organizationName">
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="estimatehours" class="form-label">Estimated Time(HH:MM)
                                            <ng-container *ngIf="getFieldInfo('timeEstimate') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"
                                            [timeOnly]="true" formControlName="timeEstimate"
                                            [defaultDate]="defaultTime">
                                        </p-calendar>
                                    </div>
                                </div>
                                <!-- <div class="col-xl-4" >
                                    <div class="mb-3">
                                        <label for="maxTime" class="form-label">Max Time</label>
                                       
                                            <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"  formControlName="maxTime" [defaultDate]="defaultTime">
                                            </p-calendar>
                                    </div>
                                </div> -->
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="isRequireEstimate" class="form-label">Required Estimate
                                            <ng-container *ngIf="getFieldInfo('isRequireEstimate') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>

                                        <input class="form-control" formControlName="isRequireEstimate"  readonly 
                                            id="isRequireEstimate">
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="taskDueDate" class="form-label">Due Date
                                            <span class="history-icon"
                                                pTooltip="View audit history" appActionTooltip>
                                                <i class="mdi mdi-history" [ngStyle]="{
                                                                                        color: 'var(--al-success)',
                                                                                        opacity: 1,
                                                                                        cursor: 'pointer'
                                                                                    }"
                                                    (click)="showAuditData(timeForm.getRawValue(), 'taskDueDate', 'Due Date')"
                                                    tabindex="0"></i>
                                            </span>
                                            <ng-container *ngIf="getFieldInfo('taskDueDate') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="datetime" formControlName="taskDueDate"
                                            readonly id="taskDueDate">
                                    </div>
                                </div>
                                <div class="col-xl-2">
                                    <div class="mb-3">
                                        <label for="dueDaySlot" class="form-label">Due Date Slot
                                            <ng-container *ngIf="getFieldInfo('dueDaySlot') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="dueDaySlot"  readonly 
                                            id="dueDaySlot">
                                    </div>
                                </div>
                                <div class="col-xl-2">
                                    <div class="mb-3">
                                        <label for="timeRecordStatus" class="form-label">Time Record Status
                                            <ng-container *ngIf="getFieldInfo('timeRecordStatus') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="timeRecordStatus"
                                            readonly id="timeRecordStatus">
                                    </div>
                                </div>
                                <div class="col-xl-2">
                                    <div class="mb-3">
                                        <label for="approveRejectBy" class="form-label">Approved/Rejected By
                                            <ng-container *ngIf="getFieldInfo('approveRejectBy') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text"  readonly 
                                            formControlName="approveRejectBy" readonly id="approveRejectBy">
                                    </div>
                                </div>
                                <div class="col-xl-2">
                                    <div class="mb-3">
                                        <label for="approveRejectOn" class="form-label">Approved/Rejected On
                                            <ng-container *ngIf="getFieldInfo('approveRejectOn') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text"  readonly 
                                            formControlName="approveRejectOn" readonly id="approveRejectOn">
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="mb-3">
                                        <label for="loggedTime" class="form-label">Logged Time(HH:MM)
                                            <ng-container *ngIf="getFieldInfo('loggedTime') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <!-- <input class="form-control" type="text" formControlName="loggedTime" readonly -->
                                        <!-- id="loggedTime"> -->
                                        <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"  readonly 
                                            [timeOnly]="true" formControlName="loggedTime" [defaultDate]="defaultTime">
                                        </p-calendar>
                                    </div>
                                </div>
                                <div class="col-xl-3">
                                    <div class="mb-3">
                                        <label for="stateDesc" class="form-label">State
                                            <ng-container *ngIf="getFieldInfo('stateDesc') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <input class="form-control" type="text" formControlName="stateDesc"  readonly 
                                            id="stateDesc">
                                    </div>
                                </div>
                                <div class="col-xl-3" *ngIf="timeForm.getRawValue().quantityRelated=='Yes'">
                                    <div class="mb-3">
                                        <label for="quantity" class="form-label">Quantity
                                        </label>

                                        <input class="form-control" type="number" formControlName="quantity"
                                            id="quantity"
                                            *ngIf="timeForm.getRawValue().quantityType?.toUpperCase() === 'NUMBER' && !(timeForm.get('quantity').disabled)">
                                        <p-multiSelect [maxSelectedLabels]="10000" appendTo="body" defaultLabel="Select State"
                                            *ngIf="timeForm.getRawValue().quantityType?.toUpperCase() == 'STATE' && !(timeForm.get('quantityState').disabled)"
                                            formControlName="quantityState" [options]="stateCodeMapList"
                                            optionLabel="label" optionValue="label"></p-multiSelect>
                                        <div id="quantityStr"
                                            *ngIf="(timeForm.getRawValue().quantityType?.toUpperCase() === 'NUMBER'  && timeForm.get('quantity').disabled )|| (timeForm.getRawValue().quantityType?.toUpperCase() == 'STATE' && timeForm.get('quantityState').disabled)"
                                            class="form-control wrap-col-text">
                                            <div *ngFor="let item of getQuantityStrList()">{{ item }}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <<div class="col-xl-2">
                                    <div style=" height: 50%;"></div>
                                    <div class="form-check mb-3">
                                        <input class="form-check-input" id="isIncludeToday" type="checkbox" formControlName="includeToday" disabled>
                                        <label class="form-check-label" for="isIncludeToday">
                                            Include Today
                                        </label>
                                    </div>
                                </div>-->
                                <!-- <div class="col-xl-2">
                                     <div style=" height: 50%;"></div>
                                    <div class="form-check mb-3">
                                        <input class="form-check-input" type="checkbox" formControlName="isBillable" disabled>
                                        <label class="form-check-label" for="isBillable">
                                            Billable
                                        </label>
                                    </div>
                                </div>  -->
                                <div class="col-xl-2">
                                    <div style=" height: 50%;"></div>
                                    <div class="form-check mb-3">
                                        <input class="form-check-input" id="isReadyToComplete" type="checkbox"
                                            formControlName="isReadyToComplete"  readonly >
                                        <label class="form-check-label" for="isReadyToComplete">
                                            Task Ready To Complete
                                            <ng-container *ngIf="getFieldInfo('isReadyToComplete') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-4" *ngIf="(onlytk || tkdashboard) && showrejectComment">
                                    <div class="mb-3">
                                        <label for="rejectComment" class="form-label">Reject Comment
                                            <ng-container *ngIf="getFieldInfo('rejectComment') as info">
                                                <info-tooltip
                                                    *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                    [infoText]="info.informationText"></info-tooltip>
                                            </ng-container>
                                        </label>
                                        <textarea class="form-control" formControlName="rejectComment"  readonly 
                                            id="rejectComment" appSpellCheck></textarea>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-3">
                                <div class="mb-3">
                                    <label for="date" class="form-label">Date</label>
                                    <!-- <input class="form-control" type="datetime" formControlName="timeRecordDueDate" readonly  id="date">  -->
                                    <p-calendar appendTo="body" formControlName="date" [maxDate]="timeRecordsDueDate"
                                        [minDate]="timeRecordsStartDate">
                                    </p-calendar>
                                    <!-- <select id="date" class="form-select" name="date"  formControlName="date">
                                        <option *ngFor="let dates of acceptedDates" [value]="dates" >{{ dates }}</option>
                                      </select> -->
                                    <!-- <span style="color:var(--al-danger)" *ngIf="!datefutureValid">Future Date is not allowed</span> -->

                                </div>
                            </div>
                            <div class="col-xl-3">
                                <div class="mb-3">
                                    <label for="enteredTime" class="form-label">Time Spent(HH:MM)
                                        <ng-container *ngIf="getFieldInfo('enteredTime') as info">
                                            <info-tooltip *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                [infoText]="info.informationText"></info-tooltip>
                                        </ng-container>
                                    </label>
                                    <p-calendar appendTo="body" [showTime]="true" hourFormat="24" [timeOnly]="true"
                                        formControlName="enteredTime" [defaultDate]="defaultTime">
                                    </p-calendar>

                                </div>
                            </div>
                            <div class="col-xl-3">
                                <div class="mb-3">
                                    <label for="description" class="form-label">Description
                                        <ng-container *ngIf="getFieldInfo('description') as info">
                                            <info-tooltip *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                [infoText]="info.informationText"></info-tooltip>
                                        </ng-container>
                                    </label>
                                    <textarea class="form-control" formControlName="description"
                                        id="description" appSpellCheck></textarea>
                                </div>
                            </div>
                            <div class="col-xl-3">
                                <div class="mb-3">
                                    <label for="tkComment" class="form-label">Time Record Comments
                                        <ng-container *ngIf="getFieldInfo('tkComment') as info">
                                            <info-tooltip *ngIf="info.showInformation === 'Yes' && info.informationText"
                                                [infoText]="info.informationText"></info-tooltip>
                                        </ng-container>
                                    </label>
                                    <textarea class="form-control" formControlName="tkComment" id="tkComment" appSpellCheck></textarea>
                                </div>
                            </div>
                            <!-- <div class="col-xl-4">
                                <div class="form-check mb-3">
                                    <input class="form-check-input" formControlName="taskCompleted" type="checkbox" >
                                    <label for="taskCompleted" class="form-label"> Task Completed</label>
                                </div>
                            </div> -->
                            <div class="col-xl-2" *ngIf="!viewonlyTR && (lpcdashboard || (!tkdashboard && !onlytk  ))">
                                <div class="form-check mb-3">
                                    <input class="form-check-input" (change)="rejectionClicked($event)" id="reject"
                                        type="checkbox">
                                    <label for="reject" class="form-label">Reject</label>
                                </div>
                            </div>
                            <div class="col-xl-4" *ngIf="showRejectField">
                                <div class="mb-3">
                                    <label for="rejectReason" class="form-label">Reject Reason</label>
                                    <p-dropdown formControlName="rejectReason" [options]="rejectStandardReasonList"
                                        (onChange)="filter($event.value)" placeholder="Any" appendTo="body">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                            </div>
                            <div class="col-xl-6" *ngIf="showRejectField">
                                <div class="mb-3">
                                    <label for="rejectComment" class="form-label">Reject Comment</label>
                                    <textarea class="form-control" placeholder="Reason For Rejection"
                                        formControlName="rejectComment"></textarea>
                                    <span style="color:var(--al-danger)" *ngIf="rejectionInvalid">Rejection Comment must be
                                        entered!</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12">
                    <div class="button-items" style="float: right;padding:10px;">
                        <span appActionTooltip
                            *ngIf="!viewonlyTR && (lpcdashboard || (!tkdashboard && !onlytk))"
                            [pTooltip]="getApproveDisabledReason() || 'Approve time record'"
                            [actionDisabled]="showRejectField || timeForm.getRawValue().disableApproveBtn || timeForm.value.isReadyToComplete === false">
                            <button class="btn btn-success" (click)="approve(true)"
                                [disabled]="showRejectField || timeForm.getRawValue().disableApproveBtn || timeForm.value.isReadyToComplete === false">
                                Approve
                            </button>
                        </span>

                        <span appActionTooltip
                            *ngIf="!viewonlyTR && (lpcdashboard || (!tkdashboard && !onlytk))"
                            [pTooltip]="!showRejectField ? 'Check Reject to enable' : 'Reject time record'"
                            [actionDisabled]="!showRejectField">
                            <button class="btn btn-danger" (click)="approve(false)"
                                [disabled]="!showRejectField">
                                Reject
                            </button>
                        </span>

                        <button class="btn btn-primary" *ngIf="!viewonlyTR && (onlytk || tkdashboard)"
                            (click)="updateTR(0)" pTooltip="Save time record" appActionTooltip style="cursor: pointer;">
                            Save
                        </button>

                        <button class="btn btn-success" *ngIf="!viewonlyTR && (onlytk || tkdashboard)"
                            (click)="updateTR(1)" pTooltip="Submit time record" appActionTooltip style="cursor: pointer;">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>
<div class="loader" *ngIf="btnLoading">
    <div class="spinner"></div>
</div>


<app-confirmation-alert [showAlert]="showConfirmAlert" [message]="confirmMessage"
    (response)="submit_reject_multiple($event=='Yes'?true:false)"></app-confirmation-alert>

<p-dialog [(visible)]="showRejectConfirmAlert" [resizable]="false" [draggable]="false" [closable]="true"
    (onHide)="closeDialog()" [style]="{width: '40%'}" header="Reject Time Record" [modal]="true" styleClass="p-fluid">

    <app-notification [errorMsg]="errorMsg"></app-notification>

    <ng-template pTemplate="content">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="mb-3">
                        <label for="rejectReason" class="form-label">Reject Reason</label><span
                            style="color:var(--al-danger);">*</span>
                        <p-dropdown [(ngModel)]="rejectReason" [options]="rejectStandardReasonList" placeholder="Any"
                            appendTo="body">
                            <ng-template let-option pTemplate="item">
                                <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="col-sm-6" style="padding-top:2%">
                        <label for="label" class="form-label mb-1">{{confirmMessage}}</label>
                    </div>


                    <div class="col-sm-3 button-items " style="padding:10px;">
                        <button type="button" class="btn btn-danger" style="float: right;"
                            (click)="submit_reject_multiple(false)"
                            pTooltip="Cancel" appActionTooltip>No</button>
                        <button type="submit" class="btn btn-success" style="float: right;"
                            (click)="submit_reject_multiple(true)"
                            pTooltip="Confirm rejection" appActionTooltip>Yes</button>
                    </div>
                </div>

            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="gridSettingsDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
    [style]="{width: '70%'}" [header]="'Grid Settings'" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <app-grid-settings-mapper  [category]="'Time Record'" [availableColumns]="availableColumns" [customCols]="customCols" [defaultColumns]="getDefaultGridColumns()" (onSaved)="saveCustomSettings();closeSettingsDialog();"></app-grid-settings-mapper>
    </ng-template>
</p-dialog>



<p-dialog [(visible)]="auditDialog" (onHide)="closeAuditDialog()" [style]="{'width': '60%', 'max-height':'75%'}"
    [resizable]="false" [draggable]="false" [header]="auditTitle" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <app-audit-table
            [tableName]="auditTableName"
            [recordId]="auditRecordId"
            [fieldName]="auditField"></app-audit-table>
    </ng-template>
</p-dialog>